'use client';

import React__default from 'react';
import SlideModal from '../Modal/SlideModal.js';
import styles from './MobileSort.module.css.js';
import IconCheck from '../icons/IconCheck.js';

var MobileSort = function (props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, _b = props.value, value = _b === void 0 ? '' : _b, _c = props.title, title = _c === void 0 ? '' : _c, _d = props.isOpen, isOpen = _d === void 0 ? false : _d, onSelected = props.onSelected, onBack = props.onBack, _e = props.showSortingHighlightMobile, showSortingHighlightMobile = _e === void 0 ? false : _e;
    return (React__default.createElement(SlideModal, { isOpen: isOpen, title: title, onBack: onBack },
        React__default.createElement("div", { className: styles.optionsContainer }, options.map(function (option) {
            var isOptionSelected = option.id === value;
            var selectedClass = isOptionSelected ? styles.selected : '';
            var isShowHighLight = showSortingHighlightMobile && option.isHighlight === true;
            return (React__default.createElement("div", { className: isShowHighLight ? "".concat(styles.sortingHighLight) : '' },
                isShowHighLight ? (React__default.createElement("svg", { height: '100%', width: '100%', onClick: function () { return onSelected && onSelected(option); } },
                    React__default.createElement("rect", { rx: '4', ry: '4', className: styles.line, height: '100%', width: '100%', strokeLinejoin: 'round' }))) : null,
                React__default.createElement("div", { className: "".concat(styles.optionItem, " ").concat(selectedClass), key: option.id, onClick: function () { return onSelected && onSelected(option); } },
                    React__default.createElement("div", null, option.name),
                    isOptionSelected && (React__default.createElement("span", { className: styles.icon },
                        React__default.createElement(IconCheck, null))))));
        }))));
};

export { MobileSort as default };
//# sourceMappingURL=index.js.map
